import { Route } from 'react-router-dom';
import {useSelector} from "react-redux";

import { Loader, RoutesInternal } from 'theSource/components';
import { useEnrollmentFamilyQuery } from 'enrollment/queries/useEnrollmentFamilyQuery';
import { FamilyDetailsPage } from './FamilyDetailsPage';
import { selectEnrollmentContext } from '../../../theSource/features/Home/components/EnrollmentBanner/services';

export const Family = () => {
  const enrollmentContext = useSelector(selectEnrollmentContext);
  const { dependentsData, isLoadingDependents, isFetchingDependents } =
    useEnrollmentFamilyQuery({ lumosEnabled: true,
      manualEnrollmentContextOverride: enrollmentContext});

  const isLoading = isLoadingDependents || isFetchingDependents;

  if (isLoading) {
    return <Loader />;
  }
  return (
    <RoutesInternal>
      <Route
        path="/"
        element={<FamilyDetailsPage dependentsData={dependentsData} />}
      />
    </RoutesInternal>
  );
};
